import { useState } from 'react';
import { Form } from 'antd';
import { z } from 'zod';
import { useNavigate } from 'react-router-dom';
import { useMessage } from '@context/MessageProvider';
import { forgotPasswordSchema } from '@validators/outside.schema';
import { useRequestPasswordResetMutation } from './useAuthMutations';

export const useForgotPassword = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { showMessage } = useMessage();
    const [submitted, setSubmitted] = useState(false);
    const resetMutation = useRequestPasswordResetMutation();

    const onFinish = async (values) => {
        try {
            const parsedValues = forgotPasswordSchema.parse(values);
            await resetMutation.mutateAsync(parsedValues.email);
            setSubmitted(true);
            navigate(`/otp?email=${encodeURIComponent(parsedValues.email)}`, { replace: true });
        } catch (error) {
            if (error instanceof z.ZodError) {
                form.setFields([
                    {
                        name: 'email',
                        errors: [error.errors[0].message],
                    },
                ]);
            } else {
                showMessage('error', error?.response?.data?.message || error?.message || 'Failed to request reset OTP', 6);
            }
        }
    };

    return {
        form,
        loading: resetMutation.isPending,
        submitted,
        onFinish,
    };
};
